import { Injectable } from '@angular/core';
import { ConfigurationService } from '@sc/data-access-configuration';
import {
  AnswerChoice,
  Glass,
  GlassUsageConfiguration,
} from '@sc/data-access-models';

@Injectable()
export class CarImgService {
  glassUsageConfiguration: GlassUsageConfiguration;
  constructor(configuration: ConfigurationService) {
    this.glassUsageConfiguration = configuration.getGlassUsage();
  }

  getAnswerById(id: string): AnswerChoice {
    const answersIdList = id.split('-');
    const answersToReturn: AnswerChoice = {
      glass: answersIdList[0] as Glass,
      sub: {},
    };
    let possibleDisplayElements =
      this.glassUsageConfiguration.treeDisplay.filter(
        (glassDisplayElement) =>
          glassDisplayElement.glass === answersToReturn.glass
      );
    for (const answerItem of answersIdList.slice(1)) {
      if (possibleDisplayElements.length === 0) {
        break;
      }
      const answerItemList = answerItem.split('_');
      possibleDisplayElements = possibleDisplayElements.filter(
        (glassDisplayElement) => {
          const possibleQuestion = glassDisplayElement.sub?.find(
            (glassQuestion) => glassQuestion.key === answerItemList[0]
          );
          if (!possibleQuestion) {
            return true;
          } else if (
            possibleQuestion.values.find(
              (possibleValue) =>
                answerItemList[1] ===
                (typeof possibleValue === 'object'
                  ? possibleValue.value
                  : possibleValue)
            )
          ) {
            answersToReturn.sub[answerItemList[0]] = answerItemList[1];
            return true;
          } else {
            return false;
          }
        }
      );
    }

    if (!possibleDisplayElements[0]) {
      if (
        this.glassUsageConfiguration.otherGlasses.find(
          (otherGlass) => otherGlass === answersToReturn.glass
        )
      ) {
        return { glass: 'other', glassExtended: null } as AnswerChoice;
      }
      return;
    }

    return {
      ...answersToReturn,
      glassExtended: possibleDisplayElements[0].glassExtended,
    };
  }
}
